<template>
    <h3 class="title-manufacturer">
        <a
            :href="href"
            :title="title"
        >{{ title }}</a>
    </h3>
</template>

<script>
    export default {
        name: 'MhManufacturerTitle',
        props: {
            manufacturer: {
                type: Object,
                required: true,
            },
            categoryIdNameMap: {
                type: Object,
                required: true,
            },
            lang: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                activeCategoryId: null,
            };
        },
        computed: {
            href() {
                const lang = this.lang === 'de' ? '' : (this.lang + '/');
                if (this.activeCategoryId && this.categoryIdNameMap[this.activeCategoryId]) {
                    return '/' + lang + this.categoryIdNameMap[this.activeCategoryId] + '/' + this.manufacturer.url;
                }
                return '/' + lang + this.manufacturer.url;
            },
            title() {
                return this.manufacturer.externalName;
            },
        },
        mounted() {
            try {
                if (window.localStorage) {
                    const favString = window.localStorage.getItem('categories.fav');
                    if (favString) {
                        this.activeCategoryId = Number.parseInt(favString.split('-')[1]);
                    }
                }
            } catch (e) {
                console.log('failed to access store', e);
            }
        },
    };
</script>
